import React, { Component } from "react";
import { Row, Col, Button, ProgressBar } from "react-bootstrap";
import axios from "axios";
import config from "../../config";
import fileDownload from "js-file-download";
import moment from "moment";
import "moment/locale/pt-br";
import { toastr } from "react-redux-toastr";

class SessionStepsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      progressBarValue: 0
    };

    this.handleClick = this.handleClick.bind(this);
    this.startProgressBar = this.startProgressBar.bind(this);
  }
  startProgressBar() {
    var self = this;
    const counter = setInterval(function() {
      if (self.state.progressBarValue === 95) {
        clearInterval(counter);
      } else {
        self.setState({
          progressBarValue: self.state.progressBarValue + 1
        });
      }
    }, 1200);
  }
  handleClick() {
    this.setState({ isLoading: true, progressBarValue: 0 });
    this.startProgressBar();

    axios({
      method: "POST",
      // headers: { "X-User-Token": getAuthToken() },
      headers: { Accept: "text/csv; charset=utf-8" },
      url: `${config.trackingReportUrl}/videos/${this.props.video.id}/sessions-steps`,
      data: {
        start_date: this.props.timeframe.start,
        end_date: this.props.timeframe.end,
        user_profile: this.props.user.profile
      }
    })
      .then(res => {
        // console.log(res.data);
        if (res.data.size === 0) {
          toastr.error("Erro ao exportar o tabelão.");
          this.setState({ isLoading: false });
          return;
        }
        toastr.success("CSV gerado com sucesso!");

        let start_date = moment(this.props.timeframe.start).format("DDMM");
        let end_date = moment(this.props.timeframe.end).format("DDMM");
        fileDownload(res.data, `tabelao-${this.props.video.title}-${start_date}-${end_date}.csv`);

        this.setState({ isLoading: false });
      })
      .catch(error => {
        toastr.error("Erro ao exportar o tabelão.");
        this.setState({ isLoading: false, progressBarValue: 100 });
      });
  }

  render() {
    const { isLoading, progressBarValue } = this.state;

    return (
      <Row>
        <Col md={12}>
          <p style={{ textAlign: "center" }}>
            O processamento da tabela de dados pode demorar até 2 minutos. Clique abaixo para começar.
          </p>
          <div style={isLoading ? {} : { display: "none" }}>
            <ProgressBar now={progressBarValue} label={`${progressBarValue}%`} />
          </div>
          <div style={{ textAlign: "center" }}>
            <Button bsStyle="primary" disabled={isLoading} onClick={!isLoading ? this.handleClick : null}>
              {isLoading ? "Exportando..." : "Exportar"}
            </Button>
          </div>
        </Col>
      </Row>
    );
  }
}

export default SessionStepsTable;



// WEBPACK FOOTER //
// ./src/components/charts/SessionStepsTable.js